export default {
	about: {
		title: false,
	},
	main: {
		tagline: true,
	},
	services: {
		disabled: true,
		title: false,
	},
	accolades: {
		title: false,
	},
	widgets: {
		title: true,
	},
	testimonials: {
		title: true,
		slideSpeed: false,
		height: false,
		style: false,
	},
	contact: {
		title: true,
		receivingEmail: false,
		contactNumber: false,
	},
};
